import React from 'react'
import { connect } from 'react-redux'
import { handleDetailsClick } from '../actions/reconciliationTypes'
import styled, { css } from 'styled-components'
import { Button } from 'reactstrap'

const Pending = styled.span`
  ${(props) =>
    props.warning &&
    css`
      color: red;
      font-weight: bold;
    `}
`

const CompanyTableItem = ({ isSales, isAdmin, index, company, handleDetailsClick }) => {
  return (
    <tr key={index}>
      <td>
        <Button color="link" onClick={() => handleDetailsClick(company.id)}>
          {company.name}
        </Button>
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        <Pending warning={company.pendingCount > 0 ? true : false}>{company.pendingCount}</Pending>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{company.productCount}</td>
      <td style={{ verticalAlign: 'middle' }}>
        <Pending warning={company.remainingProductCount > 0 ? true : false}>{company.remainingProductCount}</Pending>
      </td>
      <td style={{ verticalAlign: 'middle' }}>
        {(isSales || isAdmin) && (
          <Button size="sm" color="primary" onClick={() => handleDetailsClick(company.id)}>
            Edit
          </Button>
        )}
      </td>
    </tr>
  )
}

const mapDispatchToProps = {
  handleDetailsClick,
}

export default connect(null, mapDispatchToProps)(CompanyTableItem)
